var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShIphone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 15") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Campaign-screen-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-14",
    stroke: "#0F0F0F",
    strokeWidth: 1.5,
    x: 0.75,
    y: 0.75,
    width: 98.5,
    height: 98.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14-Copy",
    transform: "translate(11, 26)",
    fillRule: "nonzero",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("g", {
    id: "left",
    transform: "translate(19, 12)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Vector",
    points: "12 24 0 12 12 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "left-copy",
    transform: "translate(53, 24) scale(-1, 1) translate(-53, -24)translate(47, 12)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Vector",
    points: "12 24 0 12 12 0"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShIphone);
export default __webpack_public_path__ + "static/media/SH_Iphone.8a06acbe943183127f5c29a04434f5af.svg";
export { ForwardRef as ReactComponent };